const STORE_ID = "GLOBAL_LOADING";

const TYPES = {
    SET_LOADING: "SET_LOADING"
}

export { STORE_ID, TYPES }